// TelegramService.js
const TELEGRAM_BOT_TOKEN = "7918152804:AAEfqKOSPdTW26F1OpWBhn3onVP3pk-6Jgs";
const TELEGRAM_CHAT_ID = "-4804422926";

function escapeMarkdown(text) {
  if (!text) return "N/A";
  // Only escape the characters that have special meaning in MarkdownV2
  // We avoid escaping numbers and only escape the specific Markdown characters
  return text.replace(/[_*[\]()~`>#+\-=|{}.!\\]/g, (match) => `\\${match}`);
}

async function sendTelegramMessage(token, chatId, message) {
  const response = await fetch(
    `https://api.telegram.org/bot${token}/sendMessage`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        chat_id: chatId,
        text: message,
        parse_mode: "MarkdownV2",
        disable_notification: true,
      }),
    }
  );
  const data = await response.json();
  if (!data.ok) {
    throw new Error(data.description);
  }
  return data;
}

async function sendWorkflowToTelegram(name, email, nodes, edges, groups) {
  const currentDateTime = new Date().toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
  });

  // Create a summary of the workflow
  const nodeTypes = nodes.reduce((acc, node) => {
    acc[node.type] = (acc[node.type] || 0) + 1;
    return acc;
  }, {});

  const workflowSummary = Object.entries(nodeTypes)
    .map(([type, count]) => `${type}: ${count}`)
    .join(', ') || 'None';

  const message = [
    `*Workflow AI Signup & Export*`,
    `*Name:* ${escapeMarkdown(name)}`,
    `*Email:* ${escapeMarkdown(email)}`,
    `*Date and Time:* ${escapeMarkdown(currentDateTime)}`,
    `*Workflow Summary:* ${escapeMarkdown(workflowSummary)}`,
    `*Node Count:* ${nodes.length}`,
    `*Edge Count:* ${edges.length}`,
    `*Group Count:* ${groups.length}`,
  ].join("\n");

  try {
    // Send the signup message first
    const data = await sendTelegramMessage(TELEGRAM_BOT_TOKEN, TELEGRAM_CHAT_ID, message);
    console.log("Telegram signup message sent:", data);
    
    // Send the full workflow as a document
    const workflowData = JSON.stringify({ nodes, edges, groups }, null, 2);
    const blob = new Blob([workflowData], { type: 'application/json' });
    
    const formData = new FormData();
    formData.append('chat_id', TELEGRAM_CHAT_ID);
    formData.append('document', blob, `workflow-${Date.now()}.json`);
    formData.append('caption', `Workflow export for ${escapeMarkdown(name)} (${escapeMarkdown(email)})`);
    
    const response = await fetch(`https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendDocument`, {
      method: 'POST',
      body: formData
    });
    
    const documentData = await response.json();
    if (!documentData.ok) {
      console.error("Error sending workflow document:", documentData.description);
    } else {
      console.log("Telegram workflow document sent:", documentData);
    }
    
    return true;
  } catch (error) {
    console.error("Error sending Telegram message:", error);
    return false;
  }
}

// Helper function to get readable service name
function getServiceName(serviceValue) {
  const serviceMap = {
    'cloud': 'Cloud Solutions',
    'software': 'Custom Software',
    'infrastructure': 'Infrastructure',
    'consulting': 'IT Strategy'
  };
  return serviceMap[serviceValue] || serviceValue || 'Not specified';
}

// Helper function to get readable budget range
function getBudgetRange(budgetValue) {
  const budgetMap = {
    '50k-100k': '$50K - $100K',
    '100k-250k': '$100K - $250K',
    '250k-500k': '$250K - $500K',
    '500k+': '$500K+'
  };
  return budgetMap[budgetValue] || budgetValue || 'Not specified';
}

// Updated function for sending contact form details with all fields
async function sendContactFormToTelegram(name, email, company, service, budget, message) {
  const currentDateTime = new Date().toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
  });

  // Log received values for debugging
  console.log('Telegram service received:', { name, email, company, service, budget, message });
  console.log('Service type:', typeof service, 'Budget type:', typeof budget);
  console.log('Service value check:', service, 'Budget value check:', budget);
  console.log('Service truthiness:', !!service, 'Budget truthiness:', !!budget);
  
  // Check if service and budget have values
  if (service) {
    console.log('Service length:', service.length);
    console.log('Service in map:', getServiceName(service));
  }
  
  if (budget) {
    console.log('Budget length:', budget.length);
    console.log('Budget in map:', getBudgetRange(budget));
  }
  
  const serviceName = getServiceName(service);
  const budgetRange = getBudgetRange(budget);
  
  console.log('Converted service name:', serviceName);
  console.log('Converted budget range:', budgetRange);
  
  const telegramMessage = [
    `*New Contact Form Submission*`,
    `*Name:* ${escapeMarkdown(name)}`,
    `*Email:* ${escapeMarkdown(email)}`,
    `*Company:* ${escapeMarkdown(company || "Not provided")}`,
    `*Service Interest:* ${escapeMarkdown(serviceName)}`,
    `*Budget Range:* ${escapeMarkdown(budgetRange)}`,
    `*Message:* ${escapeMarkdown(message || "No message provided")}`,
    `*Date and Time:* ${escapeMarkdown(currentDateTime)}`,
  ].join("\n");

  console.log('Formatted Telegram message:', telegramMessage);
  
  try {
    const data = await sendTelegramMessage(TELEGRAM_BOT_TOKEN, TELEGRAM_CHAT_ID, telegramMessage);
    console.log("Telegram contact form message sent:", data);
    return true;
  } catch (error) {
    console.error("Error sending Telegram message:", error);
    return false;
  }
}

export { sendWorkflowToTelegram, sendContactFormToTelegram, getServiceName, getBudgetRange };
